module.exports = __webpack_public_path__ + "static/media/benz-8.34623fd6.jpg";